// src/Core/Data/canadianCities.ts
// Comprehensive list of Canadian cities and towns across all provinces/territories

export const CANADIAN_CITIES: string[] = [
  // Ontario
  "Toronto", "Ottawa", "Mississauga", "Brampton", "Hamilton", "London",
  "Markham", "Vaughan", "Kitchener", "Windsor", "Richmond Hill", "Oakville",
  "Burlington", "Oshawa", "Barrie", "St. Catharines", "Cambridge", "Kingston",
  "Whitby", "Guelph", "Thunder Bay", "Waterloo", "Chatham", "Brantford",
  "Sudbury", "Pickering", "Ajax", "Milton", "Niagara Falls", "Peterborough",
  "Sault Ste. Marie", "Kawartha Lakes", "Sarnia", "North Bay", "Belleville",
  "Cornwall", "Welland", "Bowmanville", "Newmarket", "Aurora", "Stouffville",
  "Etobicoke", "Scarborough", "North York", "East York", "York", "Mississauga",
  "Orangeville", "Orillia", "Cobourg", "Stratford", "Woodstock", "Owen Sound",
  "Collingwood", "Midland", "Penetanguishene", "Innisfil", "Bradford", "Wasaga Beach",
  "Tillsonburg", "Leamington", "Simcoe", "Port Colborne", "Fort Erie", "Grimsby",
  "Lincoln", "Thorold", "Pelham", "Wainfleet", "West Lincoln", "Haldimand",
  "Norfolk", "Brant", "Haliburton", "Bracebridge", "Gravenhurst", "Huntsville",
  "Parry Sound", "Espanola", "Elliot Lake", "Timmins", "Kapuskasing", "Kenora",
  "Dryden", "Fort Frances", "Sioux Lookout", "Geraldton", "Hearst", "Iroquois Falls",
  "Kirkland Lake", "Cochrane", "New Liskeard", "Temiskaming Shores",

  // Quebec
  "Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke",
  "Saguenay", "Lévis", "Trois-Rivières", "Terrebonne", "Saint-Jean-sur-Richelieu",
  "Repentigny", "Brossard", "Dollard-des-Ormeaux", "Saint-Jérôme", "Drummondville",
  "Granby", "Blainville", "Saint-Hyacinthe", "Shawinigan", "Joliette", "Rimouski",
  "Victoriaville", "Rouyn-Noranda", "Val-d'Or", "Châteauguay", "Mascouche",
  "Mirabel", "Boisbriand", "Sainte-Julie", "Varennes", "Boucherville", "Saint-Bruno",
  "Alma", "Baie-Comeau", "Sept-Îles", "Sorel-Tracy", "Saint-Georges", "Thetford Mines",
  "Magog", "Cowansville", "Lachute", "Mont-Laurier", "Sainte-Agathe-des-Monts",
  "Rosemère", "Deux-Montagnes", "Pointe-Claire", "Kirkland", "Beaconsfield",

  // British Columbia
  "Vancouver", "Surrey", "Burnaby", "Richmond", "Abbotsford", "Coquitlam",
  "Kelowna", "Langley", "Saanich", "Delta", "North Vancouver", "Kamloops",
  "Nanaimo", "Victoria", "Chilliwack", "Prince George", "Vernon", "Courtenay",
  "Penticton", "Maple Ridge", "Port Coquitlam", "New Westminster", "West Vancouver",
  "Port Moody", "Langford", "Campbell River", "White Rock", "Mission", "Fort St. John",
  "Cranbrook", "Prince Rupert", "Terrace", "Williams Lake", "Quesnel", "Dawson Creek",
  "Trail", "Castlegar", "Nelson", "Kimberley", "Merritt", "Salmon Arm",
  "Armstrong", "Enderby", "Revelstoke", "Golden", "Fernie", "Sparwood",
  "Squamish", "Whistler", "Powell River", "Port Alberni", "Parksville", "Qualicum Beach",
  "Duncan", "Lake Cowichan", "Sidney", "Colwood", "Oak Bay", "View Royal",

  // Alberta
  "Calgary", "Edmonton", "Red Deer", "Lethbridge", "St. Albert", "Medicine Hat",
  "Grande Prairie", "Airdrie", "Spruce Grove", "Leduc", "Fort Saskatchewan",
  "Camrose", "Lloydminster", "Cochrane", "Okotoks", "Chestermere", "Lacombe",
  "Wetaskiwin", "Beaumont", "Cold Lake", "Fort McMurray", "Brooks", "Olds",
  "Canmore", "Banff", "Jasper", "Drumheller", "Innisfail", "Stettler",
  "Ponoka", "Drayton Valley", "Hinton", "Edson", "Whitecourt", "Slave Lake",
  "High Prairie", "Peace River", "Falher", "McLennan", "High Level", "Grimshaw",
  "Bonnyville", "Vegreville", "Vermilion", "Two Hills", "Wainwright",

  // Manitoba
  "Winnipeg", "Brandon", "Steinbach", "Thompson", "Portage la Prairie",
  "Selkirk", "Morden", "Winkler", "Dauphin", "The Pas", "Flin Flon",
  "Swan River", "Virden", "Neepawa", "Carman", "Altona", "Morris",
  "Stonewall", "Gimli", "Beausejour", "Niverville", "Lac du Bonnet",

  // Saskatchewan
  "Saskatoon", "Regina", "Prince Albert", "Moose Jaw", "Swift Current",
  "Yorkton", "North Battleford", "Estevan", "Weyburn", "Lloydminster",
  "Melfort", "Humboldt", "Meadow Lake", "Kindersley", "Melville",
  "Nipawin", "Tisdale", "Canora", "Wadena", "Wynyard", "Martensville",
  "Warman", "Pilot Butte", "White City", "Emerald Park",

  // Nova Scotia
  "Halifax", "Dartmouth", "Sydney", "Truro", "New Glasgow", "Glace Bay",
  "Kentville", "Amherst", "Bridgewater", "Windsor", "Antigonish", "Yarmouth",
  "Wolfville", "Digby", "Shelburne", "Liverpool", "Lunenburg", "Pictou",
  "Stellarton", "Westville", "Springhill", "Oxford", "Parrsboro",

  // New Brunswick
  "Fredericton", "Moncton", "Saint John", "Dieppe", "Riverview", "Bathurst",
  "Edmundston", "Miramichi", "Campbellton", "Sackville", "Sussex", "Oromocto",
  "Grand Falls", "Woodstock", "Caraquet", "Shippagan", "Tracadie",

  // Newfoundland and Labrador
  "St. John's", "Mount Pearl", "Corner Brook", "Conception Bay South",
  "Grand Falls-Windsor", "Paradise", "Gander", "Happy Valley-Goose Bay",
  "Labrador City", "Stephenville", "Clarenville", "Marystown", "Carbonear",
  "Deer Lake", "Wabush", "Channel-Port aux Basques", "Placentia",

  // Prince Edward Island
  "Charlottetown", "Summerside", "Stratford", "Cornwall", "Montague",
  "Souris", "Alberton", "Kensington",

  // Northwest Territories
  "Yellowknife", "Hay River", "Inuvik", "Fort Smith", "Behchokǫ̀",
  "Fort Simpson", "Norman Wells", "Fort Good Hope",

  // Yukon
  "Whitehorse", "Dawson City", "Watson Lake", "Haines Junction",
  "Carmacks", "Faro", "Mayo", "Teslin",

  // Nunavut
  "Iqaluit", "Rankin Inlet", "Arviat", "Baker Lake", "Cambridge Bay",
  "Pond Inlet", "Igloolik", "Pangnirtung", "Kugluktuk", "Cape Dorset",
];